import { JobOutput } from 'types';

export enum JobsActionTypes {
  UPDATE_JOBOUTPUTS = '@@settings/UPDATE_JOBOUTPUTS',
  UPDATE_DOCUMENTS = '@@settings/UPDATE_DOCUMENTS',
}

export interface JobsState {
  jobFiles: JobOutput[];
  documents: JobOutput[];
}
